module.exports = ".showing {\n  font-size: 14px !important\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/search-count/search-count.component.css
// module id = ./src/app/shared/search-count/search-count.component.css
// module chunks = main